import React from "react";

export default function VerseMarquee() {
  const items = [
    "AS IRON SHARPENS IRON",
    "— PROVERBS 27:17 —",
    "SO ONE MAN SHARPENS ANOTHER",
    "— FORGE. LEAD. WORSHIP. —",
    "TRAIN HARD",
    "— LEAD WELL —",
    "PERFORM FOR HIM"
  ];
  return (
    <section className="relative py-10 md:py-14 border-y hairline overflow-hidden">
      <div className="marquee-track whitespace-nowrap flex">
        {[...items, ...items, ...items].map((t, i) => (
          <span key={i} className="font-display italic text-[10vw] md:text-[7vw] leading-none px-8 text-[var(--text)] opacity-[0.9]">
            {t}
            <span className="inline-block mx-8 text-[var(--ember-2)]">◆</span>
          </span>
        ))}
      </div>
    </section>
  );
}
